import { FC, HTMLAttributes, useState } from "react";
import { useStyles } from "./EditProfile.style";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Typography } from "../../components/core/Typography/Typography";
import { TypographyVariant } from "../../constants/typography";
import AppBar from "../../components/common/AppBar/AppBar";
import { Icon } from "../../components/core/Icon/Icon";
import { TextField } from "../../components/core/TextField";
import { Regex } from "../../models/regex";
import clsx from "classnames";
import { updateUserGQL, meGQL } from "../../graphql";
import { useAppDispatch } from "../../components/hooks";
import { showSnackbar } from "../../store/slices/alert";
import { useTranslation } from "react-i18next";
import { HistoryGaming } from "../../models/historyGaming";
import { useNavigate } from "react-router-dom";
import { Button } from "@onmo/ui";

export const EditProfile: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [fetchUser] = useLazyQuery(meGQL);
  const { data: dataMe } = useQuery(meGQL);
  const [updateUserMutation] = useMutation(updateUserGQL);
  const [username, setUsername] = useState(dataMe?.me?.username);

  const isInvalidUsername = !Regex.isValidUsername(username || "") || !username;
  const isDisabled = isInvalidUsername || username === dataMe?.me?.username;

  const onUpdateUser = async () => {
    try {
      if (isDisabled) return;
      await updateUserMutation({
        variables: {
          input: {
            username: username?.trim(),
          },
        },
      });
      fetchUser({ fetchPolicy: "network-only" });
      dispatch(showSnackbar(t("common_Username updated successfully")));
      HistoryGaming.back(navigate);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar
        leftItems={
          <Icon
            name="icon-bold-arrow-left-3"
            onClick={() => HistoryGaming.back(navigate)}
            data-testid="back-icon"
          />
        }
        centerItems={
          <Typography
            variant={TypographyVariant.BodyB4Medium}
            data-testid="edit-username-title"
          >
            {t("Username")}
          </Typography>
        }
      />
      <div className={classes.container}>
        <TextField
          fullWidth
          inputProps={{
            placeholder: t("common_Username"),
            value: dataMe?.me.username,
            "data-testid": "username-input",
          }}
          descriptionMessage={t(
            "profile_Username can contain between 3 to 16 characters.",
          )}
          isShowClear
          onChangeValue={setUsername}
          isError={isInvalidUsername}
        />
        <br />
        <br />
        <Button
          variant={"contained"}
          size="large"
          fullWidth
          onClick={onUpdateUser}
          className={clsx(classes.btnContent, {
            [classes.disabledButton]: isInvalidUsername || isDisabled,
          })}
        >
          {t("common_Save")}
        </Button>
      </div>
    </div>
  );
};
